import { render, staticRenderFns } from "./AocAddedPrompt.vue?vue&type=template&id=34ed768e&"
import script from "./AocAddedPrompt.vue?vue&type=script&lang=js&"
export * from "./AocAddedPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports